export const siteInfo = {
  name: '黑料社区',
  tagline: '最新爆料聚集地',
  description: '黑料社区是网络热门爆料与深度挖掘的核心聚集平台，汇聚最新明星黑料、娱乐圈内幕、网红翻车事件及各类独家爆料内容，社区成员实时分享、讨论与互动。',
  founded: '2020年',
  members: '500万+',
  dailyActive: '80万+',
  articlesCount: '10万+',
  features: [
    {
      title: '实时爆料',
      description: '社区成员24小时实时分享最新爆料，第一时间掌握娱乐圈动态，不错过任何劲爆消息。',
      icon: 'ri-flashlight-line',
    },
    {
      title: '深度挖掘',
      description: '专业调查团队深入追踪每一条线索，为你呈现事件背后的真相与内幕。',
      icon: 'ri-search-eye-line',
    },
    {
      title: '社区互动',
      description: '百万用户在线讨论，分享观点、交流看法，打造最具活力的娱乐资讯社区。',
      icon: 'ri-chat-smile-2-line',
    },
    {
      title: '独家内容',
      description: '众多独家爆料只在黑料社区首发，让你比其他人更早知道娱乐圈的大事小情。',
      icon: 'ri-vip-crown-line',
    },
  ],
  reputation: [
    {
      name: '微博用户 @娱乐观察家',
      content: '黑料社区的爆料速度真的太快了，很多新闻都是他们首发之后其他媒体才跟进。关注了他们一年，信息质量值得信赖。',
      rating: 5,
      date: '2024-07-15',
    },
    {
      name: '知乎用户 @圈内老炮儿',
      content: '作为在这个行业摸爬滚打了十几年的人，我可以负责任地说，黑料社区的很多独家内容确实有真材实料，不是那种捕风捉影的营销号。',
      rating: 5,
      date: '2024-07-20',
    },
    {
      name: '豆瓣用户 @吃瓜一线',
      content: '自从发现了黑料社区，再也不用在微博上刷半天找瓜吃了。这里的分类很清晰，想看哪个明星的料直接搜就行，而且不会像其他地方那样全是广告。',
      rating: 4,
      date: '2024-07-28',
    },
    {
      name: '小红书用户 @追星少女日记',
      content: '其实一开始是拒绝的，觉得看黑料不太好。但看了几篇后发现他们做得很专业，不是那种无脑黑，而是有逻辑、有证据的分析，现在已经成为我每日必刷的平台了。',
      rating: 5,
      date: '2024-08-01',
    },
    {
      name: 'B站用户 @硬核瓜农',
      content: '黑料社区的深度挖掘栏目做得特别好，每篇文章都像看推理小说一样，一环扣一环。而且评论区也很有营养，不像其他地方全是水军。',
      rating: 5,
      date: '2024-08-03',
    },
    {
      name: '微信用户 @匿名用户',
      content: '信息更新及时，界面简洁干净，没有烦人的弹窗广告。作为一个吃瓜群众，这里是目前体验最好的平台，没有之一。',
      rating: 4,
      date: '2024-08-05',
    },
  ],
  contact: {
    email: 'tips@heiliao.community',
    wechat: 'heiliao_official',
    weibo: '@黑料社区官方',
    address: '中国上海市浦东新区张江高科技园区',
    phone: '400-888-6666',
  },
};